/* Mold Labs — scroll reveal.
   Gently fades + lifts key blocks as they enter the viewport. Self-contained,
   sets paint directly on elements (style-strip proof), respects reduced-motion,
   and fails open (content always ends visible). Uses a scroll/resize check
   rather than IntersectionObserver for maximum reliability. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTORS = [
    '.ml-hero__copy', '.ml-hero__media',
    '.ml-trust__cell',
    '.ml-featured__head', '.ml-featured__grid > *',
    '.ml-tiles__grid > *',
    '.ml-material__copy', '.ml-material__media',
    '.ml-values__grid > *',
    '.ml-quote__text', '.ml-quote__attr',
    '.ml-cta__inner',
    '.ml-coll__banner', '.ml-coll__grid > *',
    '.ml-pdp__gallery', '.ml-pdp__buybox', '.ml-pdp__related-grid > *',
    '.ml-contactpage__head', '.ml-contactpage__info', '.ml-contactpage__card',
    '.ml-search__head', '.ml-search__grid > *',
    '.ml-about__hero', '.ml-about__story > *', '.ml-about__stat', '.ml-about__values-grid > *', '.ml-about__cta',
    '.ml-legal__content > h2',
    '.ml-upsell__head', '.ml-upsell__grid > *',
    '.ml-footer__top'
  ];

  function collect() {
    var seen = [];
    SELECTORS.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        if (seen.indexOf(nodes[i]) === -1) { seen.push(nodes[i]); }
      }
    });
    return seen;
  }

  function run() {
    var els = collect();
    if (!els.length || reduce) { return; }

    els.forEach(function (el) {
      if (el.__mlReveal) { return; }
      el.__mlReveal = true;
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .6s cubic-bezier(.22,1,.36,1), transform .6s cubic-bezier(.22,1,.36,1)';
      el.style.willChange = 'opacity, transform';
    });

    function reveal(el) {
      if (el.__mlShown) { return; }
      el.__mlShown = true;
      // stagger among revealed siblings
      var parent = el.parentNode, idx = 0;
      if (parent) {
        var sibs = [].slice.call(parent.children).filter(function (c) { return c.__mlReveal; });
        idx = Math.max(0, sibs.indexOf(el));
      }
      el.style.transitionDelay = Math.min(idx * 80, 320) + 'ms';
      el.style.opacity = '1';
      el.style.transform = 'none';
    }

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var pending = false;
      els.forEach(function (el) {
        if (el.__mlShown) { return; }
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) { reveal(el); }
        else { pending = true; }
      });
      return pending;
    }

    // initial pass (twice, to catch layout settling), then on scroll/resize
    check();
    requestAnimationFrame(check);
    var onScroll = function () { if (!check()) { window.removeEventListener('scroll', onScroll); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', check, { passive: true });

    // fail-open safety net
    setTimeout(function () { els.forEach(reveal); }, 4500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
})();
